import config from "appConfig";

const walls = {
  "1-2-3-4": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/1-2-3-4.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-1-2-3-4.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-2.svg`,
  },
  "1-2-3-5": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/1-2-3-5.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-1-2-3-5.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-3.svg`,
  },
  "1-2-3-6": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/1-2-3-6.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-1-2-3-6.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-4.svg`,
  },
  "1-2-4-5": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/1-2-4-5.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-1-2-4-5.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-6.svg`,
  },
  "1-2-4-6": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/1-2-4-6.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-1-2-4-6.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-2.svg`,
  },
  "1-2-5-6": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/1-2-5-6.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-1-2-5-6.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-3.svg`,
  },
  "1-3-4-5": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/1-3-4-5.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-1-3-4-5.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-2.svg`,
  },
  "1-3-4-6": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/1-3-4-6.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-1-3-4-6.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-7.svg`,
  },
  "1-3-5-6": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/1-3-5-6.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-1-3-5-6.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-4.svg`,
  },
  "1-4-5-6": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/1-4-5-6.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-1-4-5-6.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-2.svg`,
  },
  "2-3-4-5": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/2-3-4-5.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-2-3-4-5.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-3.svg`,
  },
  "2-3-4-6": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/2-3-4-6.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-2-3-4-6.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-4.svg`,
  },
  "2-3-5-6": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/2-3-5-6.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-2-3-5-6.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-8.svg`,
  },
  "2-4-5-6": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/2-4-5-6.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-2-4-5-6.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-3.svg`,
  },
  "3-4-5-6": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/3-4-5-6.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-3-4-5-6.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-4.svg`,
  },
};

export default walls;
